import { Box, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import CustomerNameTagButton from '../CustomerNameTagButton';
import {
  BooleanInput,
  FormDataConsumer,
  GetListParams,
  Labeled,
  maxLength,
  minValue,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  Toolbar,
  useDataProvider
} from 'react-admin';
import DateTimeInputUTC from '../DateTimeInputUTC';
import { addMinuteToDate, getChainId } from '../../lib';
import { TagType } from '../../models';
import { RichTextInputCustom } from '../RichTextInputCustom';
import AiTextInput from '../AiTextInput';

export enum ScreenType {
  create = 'create',
  customer = 'customer',
};

const FormUnifiedSend = ({ screenType = ScreenType.create }: { screenType?: ScreenType }) => {
  const nowDatePlus10Minutes = () => addMinuteToDate(new Date(), 10);

  const titleInputRef = useRef<HTMLInputElement>(null);
  const pushInputRef = useRef<HTMLInputElement>(null);

  const [clientCategories, setClientCategories] = React.useState<any[]>([]);
  const [clientGroup, setClientGroup] = React.useState<any[]>([]);
  const [stationGroup, setStationGroup] = React.useState<any[]>([]);
  const [tagClient, setTagClient] = React.useState<any[]>([]);
  const [tagStation, setTagStation] = React.useState<any[]>([]);
  const [inputUsed, setInputUsed] = React.useState<string>("");

  const [counterCharSms, setCounterCharSms] = React.useState(0);
  const [counterCharPush, setCounterCharPush] = React.useState(0);

  const MAX_LENGTH_SMS = 160;
  const MAX_LENGTH_PUSH = 130;

  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider.getList('client-categories', { filter: {}, sort: { field: 'label', order: 'ASC' } } as GetListParams).then(({ data }) => {
      setClientCategories(data);
    });
    dataProvider.getList(`chains/${getChainId()}/customer-groups`, { filter: {}, sort: { field: 'name', order: 'ASC' } } as GetListParams).then(({ data }) => {
      setClientGroup(data);
    });
    dataProvider.getList(`chains/${getChainId()}/station-groups`, { filter: {}, sort: { field: 'name', order: 'ASC' } } as GetListParams).then(({ data }) => {
      setStationGroup(data);
    });
    dataProvider.getList(`chains/${getChainId()}/tag`, { filter: { type: TagType.client }, sort: { field: 'name', order: 'ASC' } } as GetListParams).then(({ data }) => {
      setTagClient(data);
    });
    dataProvider.getList(`chains/${getChainId()}/tag`, { filter: { type: TagType.station }, sort: { field: 'name', order: 'ASC' } } as GetListParams).then(({ data }) => {
      setTagStation(data);
    });
  }, []);

  const counterCharInput = (inputName: string, valueInput: string) => {
    const valueFormater = valueInput.length
    switch (inputName) {
      case 'sms':
        setCounterCharSms(valueFormater);
        break;

      case 'push':
        setCounterCharPush(valueFormater);
        break;

      default:
        break;
    }
  }

  const changeInputUsed = (inputNameUsed, value) => {
    value ? setInputUsed(inputNameUsed) : setInputUsed("");
  }

  const isDisabled = (value) => {
    return inputUsed === value || inputUsed === "" ? false : true;
  }

  return (
    <>
      {screenType === ScreenType.create && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }} >
            <SelectInput
              label='Categoria de Cliente'
              source="clientCategoryId"
              optionText="label"
              optionValue="id"
              choices={clientCategories}
              style={{ width: '25%' }}
              disabled={isDisabled('category')}
              emptyText="ra.action.clear_input_value"
              onChange={(e) => changeInputUsed('category', e.target.value)}
            />
            <p style={{ marginLeft: '1rem', marginRight: '1rem' }}>Ou</p>
            <SelectInput
              label="Grupo de Cliente"
              source="customerGroupId"
              optionText="name"
              optionValue="id"
              choices={clientGroup}
              style={{ width: '25%' }}
              disabled={isDisabled('group')}
              emptyText="ra.action.clear_input_value"
              onChange={(e) => changeInputUsed('group', e.target.value)}
            />
            <p style={{ marginLeft: '1rem', marginRight: '1rem' }}>Ou</p>
            <SelectInput
              label="Grupo de Postos"
              source="stationGroupId"
              optionText="name"
              optionValue="id"
              choices={stationGroup}
              style={{ width: '25%' }}
              disabled={isDisabled('station')}
              emptyText="ra.action.clear_input_value"
              onChange={(e) => changeInputUsed('station', e.target.value)}
            />
            <p style={{ marginLeft: '1rem', marginRight: '1rem' }}>Ou</p>
            <SelectInput
              label="Etiqueta (clientes)"
              source="customerTagId"
              optionText="name"
              optionValue="id"
              choices={tagClient}
              style={{ width: '25%' }}
              disabled={isDisabled('customerTag')}
              emptyText="ra.action.clear_input_value"
              onChange={(e) => changeInputUsed('customerTag', e.target.value)}
            />
            <p style={{ marginLeft: '1rem', marginRight: '1rem' }}>Ou</p>
            <SelectInput
              label="Etiqueta (postos)"
              source="stationTagId"
              optionText="name"
              optionValue="id"
              choices={tagStation}
              style={{ width: '25%' }}
              disabled={isDisabled('stationTag')}
              emptyText="ra.action.clear_input_value"
              onChange={(e) => changeInputUsed('stationTag', e.target.value)}
            />
          </div>
          <SelectInput
            source="gender"
            label="Sexo do Cliente"
            choices={[
              { id: 'F', name: 'Feminino' },
              { id: 'M', name: 'Masculino' },
            ]}
            style={{ width: '25%' }}
            emptyText="Todos"
          />
        </>
      )}
      <BooleanInput source="sendNow" label="Enviar agora" sx={{ width: 'auto' }} />
      <FormDataConsumer>
        {({ formData }) => {
          if (formData.sendNow) {
            return (
              <Typography variant="subtitle1" gutterBottom>
                A notificação pode demorar até 10 minutos para ser enviada.
              </Typography>
            )
          }
        }}
      </FormDataConsumer>
      <FormDataConsumer>
        {({ formData }) => {
          if (!formData.sendNow) {
            return <DateTimeInputUTC
              source={"sendAt"}
              label="Data de Envio"
              sx={{ width: 250 }}
              validate={[required(), minValue(
                nowDatePlus10Minutes(),
                'A hora de envio deve ser no mínimo 10 minutos apartir de agora',
              )]}
            />
          }
        }}
      </FormDataConsumer>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
        <AiTextInput
          source="title"
          label="Título"
          fieldType="title notification push"
          validate={[required(), maxLength(65)]}
          InputProps={{ autoComplete: 'off', inputRef: titleInputRef }}
          sx={{ width: '50%' }}
        />
        <Box sx={{ mt: 2 }}>
          <CustomerNameTagButton inputRef={titleInputRef} />
        </Box>
      </Box>
      <Box sx={{
        width: 'auto',
        '& .ql-editor': {
          minHeight: 200
        }
      }}>
        <Labeled label="Descrição: ">
          <RichTextInputCustom
            source="body"
            label="Essa mensagem pode conter formatações e será exibida no aplicativo, na tela de notificação. Ela NÃO será enviada na notificação PUSH e no SMS"
            validate={required()}
          />
        </Labeled>
      </Box>
      {/* <Labeled label="Enviar via: ">
    <>
        <BooleanInput source="sms" label="SMS" />
        <BooleanInput source="pushNotification" label="Notificação no aplicativo" />
    </>
</Labeled> */}
      <FormDataConsumer>
        {({ formData }) => {
          if (formData.sms) {
            return (
              <Labeled label="Esta mensagem será enviada no SMS: " sx={{ width: '70%' }}>
                <>
                  <TextInput
                    style={{ width: '100%' }}
                    source="smsMessage"
                    label="Mensagem SMS"
                    validate={[required(), maxLength(MAX_LENGTH_SMS)]}
                    inputProps={{ autoComplete: 'off' }}
                    onChange={(e) => counterCharInput('sms', e.target.value)}
                  />
                  <Box
                    component="span"
                    sx={{
                      top: '35%',
                      right: '1%',
                      width: 'auto',
                      height: '100%',
                      fontSize: 12,
                      opacity: 0.75,
                      fontFamily: 'Helvetica',
                      textAlign: 'end',
                    }}
                  >
                    {counterCharSms}/{MAX_LENGTH_SMS}
                  </Box>
                </>
              </Labeled>
            );
          }
        }}
      </FormDataConsumer>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
        <Labeled label="Esta mensagem será enviada na notificação Push:" sx={{ width: '70%' }}>
          <>
            <AiTextInput
              style={{ width: '100%' }}
              source="pushMessage"
              label="Mensagem Push"
              fieldType="push notification message, max 130 characters"
              validate={[required(), maxLength(MAX_LENGTH_PUSH)]}
              InputProps={{ autoComplete: 'off', inputRef: pushInputRef }}
              onChange={(e) => counterCharInput('push', e.target.value)}
              helperText={false}
            />
            <Box
              component="span"
              sx={{
                top: '35%',
                right: '1%',
                width: 'auto',
                height: '100%',
                fontSize: 12,
                opacity: 0.75,
                fontFamily: 'Helvetica',
                textAlign: 'end',
              }}
            >
              {counterCharPush}/{MAX_LENGTH_PUSH}
            </Box>
          </>
        </Labeled>
        <Box sx={{ mt: 5 }}>
          <CustomerNameTagButton inputRef={pushInputRef} />
        </Box>
      </Box>
    </>
  );
};

export default FormUnifiedSend;
